module.exports = __webpack_public_path__ + "img/head-static-serv_bg.38ea3e13.png";